<nz-page-header-content>
  <div class="flex justify-between items-center flex-wrap gap-2 mb-4">
    <nz-radio-group [(ngModel)]="quickFilter" (ngModelChange)="filterData()" nzButtonStyle="outline">
      <label nz-radio-button nzValue="all" class="font-semibold radio-button-primary">
        <i nz-icon nzType="unordered-list" nzTheme="outline" class="mr-2"></i>
        All {{counts.total_count}}
      </label>
      <label nz-radio-button nzValue="active" class="font-semibold radio-button-success">
        <i nz-icon nzType="hezky:Gateway" nzTheme="outline" class="mr-2"></i>
        Active {{counts.active_count}}
      </label>
      <label nz-radio-button nzValue="inActive" class="font-semibold radio-button-warning">
        <span class="text-[9px] text-[#B7B7B7]">x</span>
        <i class="mr-2" style="font-size: 14px !important;color: rgb(176, 180, 180);" nz-icon
          [nzType]="'hezky:Signal'"></i>
        Inactive {{counts.inactive_count}}
      </label>
    </nz-radio-group>
    <div class="flex justify-between items-center flex-nowrap gap-2">
      <nz-input-group [nzPrefix]="searchIcon">
        <input nz-input class="w-full" type="search" [(ngModel)]="searchText" placeholder="Search here..."
          (ngModelChange)="getSearchDetails(searchText)">
      </nz-input-group>
      <ng-template #searchIcon>
        <span nz-icon nzType="search" aria-hidden="true"></span>
      </ng-template>
      <button nz-button nzType="default" type="button" [nzTooltipColor]="'#fff'" nz-tooltip nzTooltipTitle="Refresh"
        nzShape="circle" (click)="refreshHandler()">
        <i nz-icon nzType="reload"></i>
      </button>
      <button nz-button nzType="primary" type="button" (click)="addEditAsset('add')"><i nz-icon nzType="plus"></i>
        Add Asset</button>
      <button nz-button nzType="primary" type="button" (click)="isExcelModalVisible = true">
        <i nz-icon nzType="plus">
        </i> Add Excel</button>
    </div>
  </div>
</nz-page-header-content>

<nz-table #assetTable nzShowSizeChanger [nzLoading]="this.apiCallLoaders['isAssetsLoading']"
  [nzScroll]="{ x: '1024px', y: '35dvh' }" [nzSize]="'small'" [nzPaginationType]="'small'" [nzShowTotal]="totalTemplate"
  [nzData]="filteredAssetList$">
  <!-- [nzPageIndex]="paginationConfig.pageIndex" [nzPageSize]="paginationConfig.pageSize" -->
  <thead>
    <tr>
      <th nzEllipsis="...">Asset ID</th>
      <th nzEllipsis="...">Asset Name</th>
      <th nzEllipsis="...">Location</th>
      <th nzEllipsis="...">Location ID</th>
      <th nzEllipsis="...">Status</th>
      <!-- @for (column of listOfColumns; track column) {
      <th [nzSortOrder]="column.sortOrder" [nzSortFn]="column.sortFn" [nzSortDirections]="column.sortDirections"
        nzEllipsis="...">
        {{ column.name }}
      </th>
      } -->
      <th>ACTIONS</th>
    </tr>
  </thead>
  <tbody>
    @for (assets of assetTable.data; track assets.asset_id) {
    <tr>
      <td nzEllipsis="...">{{ assets?.asset_id}}</td>
      <td nzEllipsis="...">{{ assets?.asset_name }}</td>
      <td nzEllipsis="...">{{ assets?.display_name }}</td>
      <td nzEllipsis="...">{{ assets?.location_id }}</td>
      <td nzEllipsis="...">
        <button nzType="default" [ngClass]="{
                  'text-green-600': assets?.is_active,
                  'text-red-600': !assets?.is_active }">
          {{ assets?.is_active ? 'Active' : 'In-Active' }}
        </button>
      </td>
      <td nzEllipsis="...">
        <span nz-tooltip="Edit" [nzTooltipColor]="'#fff'" nz-icon nzType="edit" nzTheme="outline"
          class="text-base text-primary cursor-pointer" (click)="addEditAsset('edit', assets)"></span>
        <span nz-tooltip="Delete" [nzTooltipColor]="'#fff'" nz-icon nzType="delete" nzTheme="outline"
          class="text-base text-danger cursor-pointer ml-5" nz-popconfirm nzPopconfirmPlacement="bottom"
          nzPopconfirmTitle="Are you sure to remove this record?" (nzOnConfirm)="deleteAsset(assets.asset_id)"></span>
      </td>
    </tr>
    }
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isExcelModalVisible" [nzTitle]="modalTitle" (nzOnCancel)="handleCancel('excel')"
  [nzWidth]="550">
  <ng-template #modalTitle>
    <div class="flex justify-between items-center">
      <span>Add Excel</span>
      <a *ngIf="excelErrLink" (click)="downloadLogFile()"
        class="text-blue-600 font-bold cursor-pointer hover:underline">
        <i nz-icon nzType="download" nzTheme="outline" class="mr-1"></i>
        Download Log
      </a>
    </div>
  </ng-template>

  <ng-template #excelContent>
    <ng-container>
      <!-- Error Message -->
      <div *ngIf="excelErr && !isSuccessMessage" class="mb-3 p-3 bg-red-50 text-red-700 border border-red-200 rounded">
        <strong>Error:</strong> {{ excelErr }}
      </div>

      <!-- Success Message -->
      <div *ngIf="excelErr && isSuccessMessage"
        class="mb-3 p-3 bg-green-50 text-green-700 border border-green-200 rounded">
        <strong>Success:</strong> {{ excelErr }}
      </div>

      <!-- Download Template Link -->
      <div *ngIf="!excelErrLink" class="mb-3 text-center flex justify-end">
        <a class="cursor-pointer hover:underline text-blue-600 font-bold" nz-popconfirm
          (nzOnConfirm)="downloadTemplate()" nzPopconfirmTitle="Are you sure to download this template file?"
          nzPopconfirmPlacement="bottom">
          <i nz-icon nzType="download" nzTheme="outline" class="mr-1"></i>
          Download Template
        </a>
      </div>

      <div class="upload-container border border-dashed border-gray-300 bg-white p-5 rounded mb-3 text-center">
        <label for="excelFile" class="custom-file-upload w-full block cursor-pointer">
          <i nz-icon nzType="upload" nzTheme="outline" class="text-primary text-[30px] block mb-2"></i>
          <input #addAssetFile type="file" id="excelFile" (change)="onFileChange($event)" accept=".xls,.xlsx,.csv"
            class="hidden">
          <p class="ant-upload-text font-medium mb-1">Click or drag file to this area to upload</p>
          <p class="ant-upload-hint text-gray-500 text-sm">File headers should match, and all fields must have
            appropriate data.</p>
        </label>
      </div>
      
      <div class="uploaded-files" *ngIf="fileList.length > 0">
        <h4 class="text-sm font-medium mb-2 text-gray-700">Uploaded Files</h4>
        <div *ngFor="let file of fileList; let i = index"
          class="uploaded-file flex items-center justify-between p-3 mb-2 bg-white border border-gray-300 rounded">
          <div class="flex items-center">
            <i nz-icon [nzType]="file.name.toLowerCase().endsWith('.xlsx') ? 'file-excel' : 'file-excel'"
              nzTheme="twotone" class="mr-2 text-base"></i>
            <span class="filename font-medium">{{ file?.name }}</span>
          </div>
          <div class="flex items-center gap-2">
            <span class="filesize text-sm text-gray-600">
              {{ (file.size / 1024 / 1024).toFixed(2) }} MB
            </span>
            <button type="button" nz-button nzType="text" nzDanger (click)="removeFile(i)"
              class="flex items-center justify-center p-1">
              <i nz-icon nzType="delete"></i>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #excelFooter>
    <div class="flex justify-end gap-3 pt-1">
      <button nz-button nzType="default" (click)="handleCancel('excel')" class="px-4">Cancel</button>
      <button nz-button nzType="primary" (click)="onExcelSubmit()" [nzLoading]="isConfirmLoading"
        class="px-4">Submit</button>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="excelContent"></ng-container>
  </ng-container>
  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="excelFooter"></ng-container>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isAssetModalVisible" [nzTitle]="'Add Asset'" (nzOnCancel)="handleCancel('asset')"
  [nzWidth]="650">

  <ng-template #assetContent>
    <form nz-form [nzLayout]="'vertical'" role="form" aria-labelledby="form" class="p-3">
      <nz-form-item class="mb-3">
        <nz-form-label [nzSpan]="24" nzRequired nzFor="name" class="pb-1">Asset Name</nz-form-label>
        <nz-form-control [nzSpan]="24" [nzErrorTip]="'Asset Name is required'">
          <input nz-input [(ngModel)]="assetFormData.asset_name" name="asset_name" class="w-full py-1 px-2"
            maxlength="100" placeholder="Enter Asset Name" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="mb-3">
        <nz-form-label [nzSpan]="24" nzRequired nzFor="location" class="pb-1">Location</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select [(ngModel)]="assetFormData.display_name" name="display_name" nzPlaceHolder="Select Location"
            class="w-full">
            <nz-option *ngFor="let option of locationOptions" [nzValue]="option.location_id"
              [nzLabel]="option.display_name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="mb-3">
        <nz-form-label [nzSpan]="24" nzRequired nzFor="environment" class="pb-1">Environment</nz-form-label>
        <nz-form-control [nzSpan]="24" [nzErrorTip]="'Environment is required'">
          <nz-select [(ngModel)]="assetFormData.environment" name="environment" nzPlaceHolder="Select Environment"
            class="w-full">
            <nz-option *ngFor="let option of environmentOptions" [nzValue]="option.environment"
              [nzLabel]="option.environment">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <div class="flex gap-4 mb-3">
        <nz-form-item class="w-1/2 mb-0">
          <nz-form-label [nzSpan]="24" nzRequired nzFor="make" class="pb-1">Make</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'Asset Make is required'">
            <input nz-input [(ngModel)]="assetFormData.make" name="make" maxlength="20" placeholder="Enter Asset Make"
              class="w-full py-1 px-2" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="w-1/2 mb-0">
          <nz-form-label [nzSpan]="24" nzRequired nzFor="model" class="pb-1">Model</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'Asset Model is required'">
            <input nz-input [(ngModel)]="assetFormData.model" name="model" maxlength="100"
              placeholder="Enter Asset Model" class="w-full py-1 px-2" />
          </nz-form-control>
        </nz-form-item>
      </div>

      <div class="flex gap-4">
        <nz-form-item class="w-1/2 mb-0">
          <nz-form-label [nzSpan]="24" nzRequired nzFor="year" class="pb-1">Year</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'Asset Year is required'">
            <nz-date-picker [(ngModel)]="assetFormData.year" name="year" class="w-full" nzFormat="YYYY" nzMode="year"
              nzPlaceHolder="Select Year"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="w-1/2 mb-0">
          <nz-form-label [nzSpan]="24" nzFor="tags" class="pb-1">Tags</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <div class="flex flex-wrap gap-2 p-2.5 bg-white rounded border border-gray-300">
              <nz-tag *ngFor="let tag of assetFormData.tag" [nzMode]="'closeable'" (nzOnClose)="handleClose(tag)"
                class="mb-1">
                {{ sliceTagName(tag) }}
              </nz-tag>
              <nz-tag *ngIf="!tagInputVisible" class="site-tag-plus cursor-pointer" (click)="showTagInput()">
                <i nz-icon nzType="plus"></i> New Tag
              </nz-tag>
              <input #tagInput id="tagInput" nz-input *ngIf="tagInputVisible" type="text" [(ngModel)]="tagInputValue"
                name="tagInputValue" style="width: 90px;" (blur)="handleTagInputConfirm()"
                (keydown.enter)="handleTagInputConfirm()" class="py-1 px-2" />
            </div>
          </nz-form-control>
        </nz-form-item>
      </div>
    </form>
  </ng-template>

  <ng-template #assetFooter>
    <div class="flex justify-end gap-3 pt-1">
      <button nz-button nzType="default" (click)="handleCancel('asset')" class="px-4">Cancel</button>
      <button nz-button nzType="primary" (click)="onFormSubmit()" [nzLoading]="isConfirmLoading"
        class="px-4">Submit</button>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="assetContent"></ng-container>
  </ng-container>
  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="assetFooter"></ng-container>
  </ng-container>
</nz-modal>

<ng-template #totalTemplate let-total>Showing {{ total }} items</ng-template>